import { Head } from '@inertiajs/inertia-vue3';
import Logo from '@/Shared/Logo';
import TextInput from '@/Shared/TextInput';
import LoadingButton from '@/Shared/LoadingButton';
export default {
  components: {
    Head: Head,
    LoadingButton: LoadingButton,
    Logo: Logo,
    TextInput: TextInput
  },
  data: function data() {
    return {
      form: this.$inertia.form({
        email: 'admin@funnl.us',
        password: 'secret',
        remember: false
      })
    };
  },
  methods: {
    login: function login() {
      this.form.post('/login');
    }
  }
};